import React, {Component} from 'react';
import {Link} from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {FaPlusCircle, FaTrash} from "react-icons/fa";

class ListHostingUsingComponent extends Component {

    loadStatus = () => {
        if ( this.props.service.status_hosting === 'on' ) {
            return (
                <span className="text-success">
                    Đang bật
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'off' ) {
            return (
                <span className="text-danger">
                    Đã tắt
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'admin_off' ) {
            return (
                <span className="text-danger">
                    Admin tắt
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'progressing' || this.props.service.status_hosting === 'waiting' ) {
            return (
                <span className="text-info">
                    Đang tạo
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'expire' ) {
            return (
                <span className="text-danger">
                    Hết hạn
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'cancel' ) {
            return (
                <span className="text-danger">
                    Đã hủy
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'delete' ) {
            return (
                <span className="text-danger">
                    Đã xóa
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'change_user' ) {
            return (
                <span className="text-danger">
                    Đã chuyển
                </span>
            )
        }
        else {
            return (
                <span className="text-danger">
                    Chưa tạo
                </span>
            )
        }
    }

    checkedService = (event) => {
        if ( event.nativeEvent.shiftKey ) {
            let value = event.target.checked;
            this.props.checkedServiceShiftKey( this.props.actionKey, value );
        } else {
            this.props.checkedService( this.props.actionKey );
        }
    }

    render() {
        return (
            <>
                {
                    this.props.service.error === 0 ? (
                        <tr>
                            <td>
                                <input type="checkbox" className="form-control" value="1" checked={this.props.service.checked}  onChange={ this.checkedService } />
                            </td>
                            <td>
                                <Link to={'/dich-vu-hosting/' + this.props.service.domain + '/chi-tiet-dich-vu-hosting.html'}>{this.props.service.domain}</Link>
                            </td>
                            <td>
                                { this.props.service.product_name }
                            </td>
                            <td>
                                { this.props.service.text_create_date }
                            </td>
                            <td>
                                {
                                    this.props.service.isExpire || this.props.service.expired ? (
                                        <>
                                            <span className="text-danger">{ this.props.service.text_next_due_date } </span>
                                            -
                                            <span className="text-danger"> { this.props.service.text_day }</span>
                                        </>
                                    ) : (
                                        <>
                                            { this.props.service.text_next_due_date } - { this.props.service.text_day }
                                        </>
                                    )
                                }
                            </td>
                            <td>
                                { this.props.service.text_total_time }
                            </td>
                            <td>
                                { this.props.service.text_billing_cycle }
                            </td>
                            <td>
                                { this.props.service.text_amount }
                            </td>
                            <td>
                                { this.loadStatus() }
                            </td>
                            <td>
                                {
                                    this.props.service.status !== 'Pending' ? (
                                        <>
                                            <OverlayTrigger
                                                delay={{ hide: 450, show: 300 }}
                                                overlay={(props) => (
                                                    <Tooltip {...props}>
                                                        Gia hạn VPS
                                                    </Tooltip>
                                                )}
                                                placement="top"
                                            >
                                                <button type="button" className="btn btn-warning btn-sm mr-1 mb-1 text-light" onClick={ () => this.props.showModal( this.props.actionKey, 'expire' ) }>
                                                    <FaPlusCircle />
                                                </button>
                                            </OverlayTrigger>
                                        </>
                                    ) : (
                                        <></>
                                    )
                                }
                                <OverlayTrigger
                                    delay={{ hide: 450, show: 300 }}
                                    overlay={(props) => (
                                        <Tooltip {...props}>
                                            Hủy VPS
                                        </Tooltip>
                                    )}
                                    placement="top"
                                >
                                    <button type="button" className="btn btn-danger btn-sm mr-1 mb-1" onClick={ () => this.props.showModal( this.props.actionKey, 'delete' ) }>
                                        <FaTrash />
                                    </button>
                                </OverlayTrigger>
                            </td>
                        </tr>
                    ) : (
                        <tr>
                            <td colSpan={15} className="text-danger text-center">
                                { this.props.service.message }
                            </td>
                        </tr>
                    )
                }
            </>
        );
    }
}

export default ListHostingUsingComponent;